var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactLoction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1241_4423)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.88867 19.0107L4.9389 14.0609C3.95994 13.082 3.29326 11.8347 3.02317 10.4768C2.75308 9.11894 2.89171 7.71148 3.42153 6.4324C3.95134 5.15332 4.84855 4.06008 5.99969 3.29091C7.15083 2.52175 8.50421 2.11121 9.88867 2.11121C11.2731 2.11121 12.6265 2.52175 13.7777 3.29091C14.9288 4.06008 15.826 5.15332 16.3558 6.4324C16.8856 7.71148 17.0243 9.11894 16.7542 10.4768C16.4841 11.8347 15.8174 13.082 14.8385 14.0609L9.88867 19.0107ZM13.7387 12.9611C14.5 12.1997 15.0185 11.2296 15.2285 10.1735C15.4386 9.11739 15.3307 8.02272 14.9186 7.02791C14.5065 6.0331 13.8087 5.18283 12.9134 4.58461C12.0181 3.98639 10.9655 3.66709 9.88867 3.66709C8.81189 3.66709 7.75928 3.98639 6.86396 4.58461C5.96864 5.18283 5.27081 6.0331 4.85872 7.02791C4.44662 8.02272 4.33877 9.11739 4.5488 10.1735C4.75883 11.2296 5.27731 12.1997 6.03867 12.9611L9.88867 16.8111L13.7387 12.9611ZM9.88867 10.6667C9.47612 10.6667 9.08045 10.5028 8.78873 10.2111C8.49701 9.91936 8.33312 9.5237 8.33312 9.11115C8.33312 8.69859 8.49701 8.30292 8.78873 8.0112C9.08045 7.71948 9.47612 7.55559 9.88867 7.55559C10.3012 7.55559 10.6969 7.71948 10.9886 8.0112C11.2803 8.30292 11.4442 8.69859 11.4442 9.11115C11.4442 9.5237 11.2803 9.91936 10.9886 10.2111C10.6969 10.5028 10.3012 10.6667 9.88867 10.6667Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1241_4423"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.6667,
    height: 18.6667,
    fill: "white",
    transform: "translate(0.554688 0.555542)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactLoction);
export default __webpack_public_path__ + "static/media/ContactLoction.ab4c69e5bfda5e2e2354f37ca2cce491.svg";
export { ForwardRef as ReactComponent };